import { IFaDanThuocSelectByCoSoRequest } from "../models/request/dan-thuoc/IFaDanThuocSelectByCoSoRequest";
import { apiClient } from "./apiClient";

export const danThuocApi = {
    select: (request: any) => apiClient.post("dan-thuoc", request),
    selectByCoso: (request: IFaDanThuocSelectByCoSoRequest) => apiClient.post("dan-thuoc/select-by-coso", request),
    selectDetail: (id: number) => apiClient.get("dan-thuoc/" + id.toString()),
    accpetAsync: (request: any) => apiClient.put('dan-thuoc/accept', request)
}